import debounce from 'lodash.debounce';
import SearchInputHTML, { updateBySeach } from './component/SearchInput';
import OptionListHTML, { updateAll } from './component/OptionList';
import OptionHTML, { selectOption, selectAllDepth } from './component/Option';
import { toggleDepth } from './component/DepthTitle';

/**
 * optionTree, optionList, optionInfo 호출
 * 단일 옵션 여부 확인
 */

export default class PurchaseSelector {
  constructor() {
    const { optionInfo, htStaticData } = TMON.oApp.htStorage;
    const { bOptionDeal, htDealInfo } = htStaticData;
    if (!optionInfo || !optionInfo.options) return;

    const { dealType } = htDealInfo;
    const { isAvailableOptionSelect } = optionInfo;

    this.bOptionDeal = bOptionDeal;
    this.isSearchRender = TMON.sDevice !== 'PW' && !['TOUR', 'CULTURE'].includes(dealType);
    this.welContainer = $('[data-role="prchSelector"]');
    this.depth = 0;

    // 옵션 선택이 가능한 경우에만 그리고 이벤트 걸어주기
    if (isAvailableOptionSelect) {
      this.render();
      this.setEvent();
    }
  }

  setEvent() {
    // depth 클릭
    this.welContainer.on('click', 'button.tit', e => {
      const depth = +e.target.dataset.index;
      toggleDepth(depth, e.delegateTarget, false);
      this.updateDepth();
      TMON.oApp.setStorage('resizeFloatingInnerCart', true);
    });

    // depth 옵션 클릭
    this.welContainer.on('click', 'button[data-role="prchSelItem"]', e => {
      const option = e.currentTarget;
      const optionListContainer = option.parentElement.parentElement;
      const { key, index: optionIndex } = option.dataset;
      const depth = +optionListContainer.dataset.depth;
      const depthElemList = document.querySelectorAll(`.dep${depth}`);
      depthElemList.forEach(depthElem => {
        const button = depthElem.children[0];
        button.textContent = option.getElementsByTagName('span')[0].textContent;
      });
      selectOption(depth, Number(optionIndex) + 1, key, e.delegateTarget);
      TMON.oApp.setStorage('resizeFloatingInnerCart', true);
    });

    if (this.isSearchRender) {
      // 옵션 검색
      const searchHandler = debounce(searchWord => {
        this.searchWord = searchWord;
        this.updateSearchResult();
      }, 300);
      this.welContainer.on('keyup', 'input.search_input', e => {
        searchHandler(e.target.value);
      });
      
      // 검색어 삭제
      this.welContainer.on('click', 'button.search_del', () => {
        this.initSearch();
      });

      // 모바일에서 옵션 검색시 키보드에 옵션이 가려져 안보이는 현상이 발생하여 input focus, blur시 옵션 height 조정 
      const optionScrollDiv = $('#_optionScroll');
      this.welContainer.on('focus', 'input.search_input', () => {
        optionScrollDiv.css('max-height', 'none');
        optionScrollDiv.height(optionScrollDiv.height() * 1.2);
      });
      this.welContainer.on('blur', 'input.search_input', () => {
        setTimeout(() => {
          optionScrollDiv.height('auto');
        }, 0)
      });
    }
  }

  /**
   * depth, depth 옵션 클릭 이벤트 해제
   */
  clearEvent() {
    if (!this.welContainer) return;
    this.welContainer.off('click', 'button.tit');
    this.welContainer.off('click', 'button[data-role="prchSelItem"]');
  }

  /**
   * htStorage가 업데이트 되었을 때 호출
   */
  update = sStorageKey => {
    const { checkOut, scene } = TMON.oApp.htStorage;

    switch (sStorageKey) {
      case 'purchaseOption':
        this.onUpdatePurchaseOption();
        break;
      case 'pickDate':
        this.onUpdatePickDate();
        break;
      case 'checkOut':
        // 체크인 액션으로 인한 체크아웃 초기화 무시
        if (checkOut) {
          this.onUpdateCheckOut();
        }
        break;
      case 'scene':
        if (scene === 'optionDetail') {
          this.updateDepth(true);
        }
        break;
      case 'drawCalenderFinish':
        this.scrollOption();
        break;
      default:
        break;
    }
  };

  /**
   * depth 옵션 선택 후
   * 다음 depth 옵션트리 조회 및 토글
   */
  async onUpdatePurchaseOption() {
    const { purchaseOption } = TMON.oApp.htStorage;
    const { aKeyList, nCurrentDepth } = purchaseOption;
    const { totalDepth, options } = TMON.oApp.htStorage.optionInfo;
    const selectedKey = aKeyList[nCurrentDepth];

    this.depth = nCurrentDepth;

    if (nCurrentDepth < totalDepth - 2) {
      await TMON.oApp.oApi.fetchApi('optionTree', {
        depth: nCurrentDepth + 2,
        parentKey: selectedKey,
      });
      this.renderOptionItem(nCurrentDepth + 1);
    } else if (nCurrentDepth === totalDepth - 2) {
      const { lastOptNos } = options[nCurrentDepth]
        .find((item) => item.key === selectedKey);
      await TMON.oApp.oApi.fetchApi('optionList', {
        aSelectedChildOptionDealSrls: lastOptNos,
      });
      const { optionList, optionInfo } = TMON.oApp.htStorage;
      // 마지막 단계의 selector가 달력일 경우 제외
      if (optionList.data.length > 0 && optionInfo.nCalendarDepth <= 0) {
        await this.renderOptionItem(optionInfo.totalDepth - 1);
      }
    }
    
    updateAll();
    this.updateDepth();
  }

  /**
   * 달력 일자 선택 후
   */
  onUpdatePickDate() {
    const { nCalendarDepth } = TMON.oApp.htStorage.optionInfo;
    const { event } = TMON.oApp.htStorage.pickDate;
    const { index: optionIndex, key } = event.currentTarget.parentElement.dataset;
    selectOption(nCalendarDepth, optionIndex, key, event.delegateTarget);
  }

  onUpdateCheckOut() {
    const { checkOut, checkIn } = TMON.oApp.htStorage;

    // UI 변경: checkIn-CheckOut 타이틀 적용, 열린 Select 닫기
    const sContainerSelector = 'div[data-role=prchSelector]';
    const welCalendarDepth = this.welContainer.find('div.dep-sel.dep-calendar');
    for (let i = 0; welCalendarDepth.length > i; i += 1) {
      $(welCalendarDepth[i])
        .find('button.tit')
        .html(
          `${checkIn.sCheckInOptionTitle} ~ ${checkOut.sCheckOutOptionTitle}`
        );
      $(checkOut.event.currentTarget)
        .closest(sContainerSelector)
        .find(welCalendarDepth[i])
        .removeClass('open');
    }
    this.updateDepth(true);
  }

  /**
   * 선택한 depth의 옵션 목록으로 데이터 업데이트, 검색 폼 초기화
   * 호출 조건
   * 1. update: optionDetail scene --> true
   * 2. depth 선택 --> false
   * 3. depth option 선택 --> false
   * 4. update: checkOut --> true
   */
  updateDepth(bCloseForce = false) {
    if (this.isSearchRender) {
      this.initSearch(); // 검색어 초기화
      const optionWrap = $('[data-role=prchWrap]');
      const moreThan10 = this.getOpenDepthData().length >= 10;
      if (moreThan10) optionWrap.addClass('depth_open');
      else optionWrap.removeClass('depth_open');
    }

    if (!bCloseForce) this.scrollOption();
  }

  /**
   * 모바일에서 옵션 내 달력이 상단으로 이동하도록
   * 옵션이 열린 후(스크롤이 먼저 일어남) 달력이 그려지는 경우 때문에 storage를 거쳐 달력이 그려진 시점을 받음)
   */
  scrollOption() {
    if (TMON.oApp.sPlatform === 'PW') return;
    const openDepth = document.querySelector('.dep-sel.open');
    if (!openDepth) return;

    const depth = +openDepth.children[0].dataset.index;
    if (depth === 0) return;
    const offsetTop = openDepth.offsetTop || 0;
    $('#_optionScroll').scrollTop(offsetTop + 15); // 간격조정
  }

  /**
   * opt_deal_srl 파라미터가 붙은 딜은 모든 depth를 업데이트
   */
  updateAllOptionUI = async () => {
    await this.getSelectedList();
    const allDepthContainer = document.querySelectorAll('div[data-role="prchSelector"]')[0];
    selectAllDepth(allDepthContainer);
  };

  // optionList 업데이트 될 떄 마지막 뎁스의 텍스트 변경
  replaceOptionHtml = () => {
    if (!this.welContainer) return;
    
    const { optionList } = TMON.oApp.htStorage;
    if (!optionList) return;

    const { data } = optionList;

    for (let j = 0; j < data.length; j += 1) {
      try {
        for (let i = 0; i < this.welContainer.length; i += 1) {
          const htDiscountInfos = TMON.oApp.oUtil.getDiscountInfos(data[j]);
          const bIsTimeOver =
            data[j].endDate && TMON.oApp.oUtil.isTimeOver(data[j].endDate);
          const elOption = this.welContainer
            .eq(i)
            .find(`li[data-optionno=${data[j].optionNo}]`);

          if (bIsTimeOver) {
            elOption
              .addClass(`${bIsTimeOver ? 'soldout' : ''}`)
              .find('button')
              .attr('disabled', true);
            if (elOption.find('[data-role="prchOptDisabled"]').length > 0) {
              // 판매종료가 매진보다 노출 우선 순위 높음
              elOption.find('[data-role="prchOptDisabled"]').html('판매종료');
            } else {
              elOption
                .find('button')
                .append('<span data-role="prchOptDisabled">판매종료</span>');
            }
          }

          elOption
            // 옵션 타이틀 옆에 가격과 매진 임박 값 표기
            .find('[data-role="prchOptTxt"]').replaceWith(`
                        ${
                          !isNaN(htDiscountInfos.price)
                            ? `<span>${TMON.util.numberWithComma(
                                htDiscountInfos.price
                              )}원</span>`
                            : ''
                        }
                        ${this.getDiscount(htDiscountInfos)}
                        ${TMON.oApp.oTemplate.getStockCount(data[j])}
                    `);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  getDiscount = htDiscountInfos => {
    if (
      htDiscountInfos.isDuplicated &&
      htDiscountInfos.viewPaymentDiscountInfoKey === 'normal'
    ) {
      return '<i>&nbsp;(추가할인)</i>';
    }

    if (
      htDiscountInfos.viewPaymentDiscountInfoKey !== 'normal' &&
      htDiscountInfos.discountAmount > 0 &&
      !isNaN(htDiscountInfos.discountAmount)
    ) {
      return `<i>&nbsp;(-${TMON.util.numberWithComma(
        htDiscountInfos.discountAmount
      )}원&darr;)</i>`;
    }

    return '';
  };

  /**
   * 옵션 Wrapper, 옵션 버튼 render
   */
  render = () => {
    const { optionInfo } = TMON.oApp.htStorage;
    const { titles } = optionInfo;
    // 옵션 검색창, depth 목록 render
    let sHtml = '';
    if (this.isSearchRender) sHtml += SearchInputHTML();
    sHtml += OptionListHTML(titles);
    this.welContainer.html(sHtml);

    this.renderOptionItem(0);
  };

  getDepthOptionList = async (depth) => {
    const { options, totalDepth } = TMON.oApp.htStorage.optionInfo;

    if (depth + 1 < totalDepth) return options[depth];

    // depth가 1인 딜은 여기서 우선 optionList를 가져옵니다.
    const { bOptionDeal, optionDealSrl } = TMON.oApp.htStorage.htStaticData;
    if (totalDepth === 1 && (!bOptionDeal || !optionDealSrl)) {
      await TMON.oApp.oApi.fetchApi('optionList', {
        aSelectedChildOptionDealSrls: options[0][0].lastOptNos,
      });
    }

    const { optionList } = TMON.oApp.htStorage;
    if (optionList && optionList.data) {
      return optionList.data;
    }

    return [];
  };

  /**
   * 옵션 Wrapper 안에 옵션 목록 render
   */
  renderOptionItem = async (depth) => {
    const { optionInfo } = TMON.oApp.htStorage;
    const { options, totalDepth } = optionInfo;

    if (options.length === 0) return;

    // 캘린더딜일 때 depthList에 값이 없어 return 되므로 return하기 전에 optionList를 호출한다.
    const optionListData = await this.getDepthOptionList(depth);
    const depthList = [...document.querySelectorAll(`.purchase_selector[data-depth="${depth}"]`)];
    if (depthList.length === 0) return;

    const optionListHTML = optionListData
      .map((option, index) => OptionHTML(option, index, this.searchWord))
      .join('');
    
    depthList.forEach(container => {
      container.innerHTML = optionListHTML;
    });

    if (document.querySelector('.dep-sel.open') && this.searchWord) {
      this.updateSearchResult();
    }

    if (depth === totalDepth - 1) {
      this.replaceOptionHtml();
    } 
  };

  /**
   * 키워드를 초기화, 전체 옵션 그리기 요청
   */
  initSearch = () => {
    this.searchWord = '';
    $('.search_input').val('');
    this.updateSearchResult();
  }

  /**
   * 검색 결과에 맞는 옵션을 다시 그리기
   */
  updateSearchResult = () => {
    // const { optionInfo } = TMON.oApp.htStorage;
    // if (this.depth === total)
    updateBySeach(this.getOpenDepthData(), this.searchWord);
    if (TMON.oApp.htStorage.optionList) this.replaceOptionHtml();
  }

  /**
   * open depth의 옵션 목록 가져오기
   */
  getOpenDepthData = () => {
    const { optionInfo, optionList } = TMON.oApp.htStorage;
    const { purchaseOption } = TMON.oApp.htStorage;
    const openDepth = document.querySelector(".dep-sel.open");
    if (!openDepth) return [];

    const depth = +openDepth.children[0].dataset.index;

    let options = [];
    if (depth === optionInfo.totalDepth - 1) {
      options = optionList.data;
    } else if (depth === 0) {
      options = optionInfo.options[0];
    } else if (depth < optionInfo.totalDepth - 1){
      options = optionInfo.options[depth].filter(
        (el) => el.parentKey === purchaseOption.aKeyList[depth - 1]
      );
    }
    return options.map((option, index) => ({ ...option, index }));
  }

  // 옵션딜일 때 해당 옵션의 상위 옵션들 정보 가져오기
  getSelectedList = async () => {
    const categoryNo = TMON.htStaticData.htCategoryInfo.sDepth1No;
    const dealNo = TMON.htStaticData.sDealNo;
    const optionDealNo = TMON.util.gup('opt_deal_srl');
    const isCalendar = !isNaN(parseInt(TMON.htStaticData.htDealInfo.calenderInfo, 10));

    const commonPath = `/api/deals/option/tree/${dealNo}/depth`;
    const commonParams = `categoryNo=${categoryNo}&calendar=${isCalendar}`;

    async function fetchSelected() {
      const url = `${commonPath}?optDealSrl=${optionDealNo}&${commonParams}`;
      const result = await fetch(url).then(res => res.json());
      return result.data.dataList[0];
    }

    function getParentKeys(keys) {
      const result = [''];
      keys.reduce((parentKey, key, index) => {
        const newKey = index === 0 ? key : `${parentKey}_${key}`;
        result.push(newKey);
        return newKey;
      }, '');
      return result;
    }

    function makeFetchList(parentKeys) {
      parentKeys.pop();
      return parentKeys.map((key, index) => {
        const url = `${commonPath}?depth=${index + 1}&parentKey=${key}&${commonParams}`;
        return fetch(url);
      });
    }

    const selectedOption = await fetchSelected();
    const { key: optionKey, lastOptNos } = selectedOption;

    await TMON.oApp.oApi.fetchApi('optionList', {
      aSelectedChildOptionDealSrls: lastOptNos,
    });
    const { optionList } = TMON.oApp.htStorage;

    if (!optionKey) {
      const index = optionList.data.findIndex(option => option.optionNo === +optionDealNo);
      TMON.oApp.htStorage.optionInfo.selectedList = [{
        item: optionList.data[index],
        idx: index,
      }];
      TMON.oApp.htStorage.optionInfo.options = [
        [...optionList.data]
      ];
    } else {
      const keys = optionKey.split('_');
      const parentKeys = getParentKeys(keys);
  
      const resultList = await Promise.all(makeFetchList([...parentKeys]))
        .then(resList => resList.map(res => res.json()))
        .then(resList => Promise.all(resList));
  
      const depthList = resultList.map((result, index) =>
        result.data.dataList.map(option => ({
          ...option,
          parentKey: parentKeys[index],
        }))
      );
      const selectedList = depthList.map((depth, index) => {
        const idx = depth.findIndex(option => option.key === parentKeys[index + 1]);
        return {
          item: depth[idx],
          idx,
        };
      });
  
      const index = optionList.data.findIndex(option => option.optionNo === +optionDealNo);
      selectedList.push({
        item: optionList.data[index],
        idx: index,
      });
  
      TMON.oApp.htStorage.optionInfo.selectedList = selectedList;
      TMON.oApp.htStorage.optionInfo.options = depthList;
    }
    TMON.oApp.setStorage('selectedActionIndex', TMON.oApp.htStorage.optionInfo.selectedList[0].idx);
  }
}
